import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import LinkArrow from '../../static/img/icon_disclosure-3x.png';
import FileIconDark from '../../static/img/file_icon_dark.png';
import FileIconLight from '../../static/img/file_icon_light.png';
import '../../static/style/fonts.css';

const Webview = ({ data, pageContext, ...props }) => {
  const content = data.markdownRemark;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
        <style type="text/css">{`
          body {
            background-color: #f3f3f5;
          }

          @media (prefers-color-scheme: dark) {
            body {
              background-color: #0d0d0f;
            }
          }
        `}</style>
      </Helmet>
      <StyledTheme
        darkMode={pageContext.darkMode}
        dangerouslySetInnerHTML={{ __html: content.html }}
      />
    </>
  );
};

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
    }
  }
`;

export default Webview;

const BaseStyling = styled.div`
  padding: 20px;
  padding-top: 12px;
  padding-bottom: 100px;
  font-family: 'SharpSans-Medium', sans-serif;

  h1,
  h2 {
    line-height: 33px;
    font-size: 26px;
    font-family: 'SharpSans-Bold', sans-serif;
    margin-top: 16px;
    margin-bottom: 24px;
  }

  h3 {
    line-height: 26px;
    font-size: 19px;
    font-family: 'SharpSans-Bold', sans-serif;
    margin-bottom: 4px;
    margin-top: 16px;
  }

  h4 {
    line-height: 20px;
    font-size: 14px;
    font-family: 'SharpSans-Bold', sans-serif;
    margin-bottom: 4px;
    margin-top: 16px;
  }

  p {
    line-height: 20px;
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 12px;
  }

  strong {
    font-family: 'SharpSans-Bold', sans-serif;
  }

  a {
    text-decoration: none;
    line-height: 20px;
    font-size: 14px;
    font-family: 'SharpSans-Medium', sans-serif;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    position: relative;
    padding: 22px 0;
  }

  li:after {
    content: '';
    position: absolute;
    right: -9px;
    top: 50%;
    background-image: url(${LinkArrow});
    background-size: contain;
    background-repeat: no-repeat;
    height: 24px;
    width: 24px;
    margin-top: -12px;
  }

  li:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    background-size: contain;
    background-repeat: no-repeat;
    height: 40px;
    width: 40px;
    margin-top: -20px;
  }

  li a {
    line-height: 20px;
    font-size: 14px;
    display: block;
    padding-right: 32px;
    padding-left: 55px;
  }

  li em {
    margin-top: 2px;
    display: block;
    font-style: normal;
    padding-right: 48px;
    padding-left: 55px;
  }

  em {
    line-height: 15px;
    font-size: 11px;
    color: #cacacf;
    margin-top: 0;
  }
`;

const StyledTheme = styled(BaseStyling)`
  background-color: #f3f3f5;
  color: #1e1f24;

  a {
    color: #226600;
  }

  li a {
    color: #1e1f24;
  }

  li:before {
    background-image: url(${FileIconLight});
  }

  em {
    color: #6c6c70;
  }

  @media (prefers-color-scheme: dark) {
    background-color: #0d0d0f;
    color: #f8f8fa;

    a {
      color: #cbff9e;
    }

    li a {
      color: #f8f8fa;
    }

    li:before {
      background-image: url(${FileIconDark});
    }

    em {
      color: #cacacf;
    }
  }
`;
